import { Action, createReducer, on } from '@ngrx/store';
import { RenewPasswordActions } from '../actions';

export const renewPasswordFeatureKey = 'renewPassword';

export interface State {
  renewPasswordLoading: boolean;
  renewPasswordSuccess: boolean;
  renewPasswordErrorMessage: string;
  renewTokenExpired: boolean;
  renewTokenErrorMessage: string;
  decodedTokenMessage: string;
  decodedTokenMessageInvalid: boolean;
  decodedTokenMessageError: string;
}

export const initialState: State = {
  renewPasswordLoading: false,
  renewPasswordSuccess: false,
  renewPasswordErrorMessage: null,
  renewTokenErrorMessage: null,
  renewTokenExpired: false,
  decodedTokenMessage: null,
  decodedTokenMessageInvalid: false,
  decodedTokenMessageError: null,
};

const renewPasswordReducer = createReducer(
  initialState,
  on(RenewPasswordActions.renewPassword, (state) => ({
    ...state,
    renewTokenExpired: false,
    renewTokenErrorMessage: null,
    renewPasswordLoading: true,
    renewPasswordSuccess: false,
    renewPasswordErrorMessage: null,
  })),
  on(RenewPasswordActions.renewPasswordSuccess, (state, { }) => ({
    ...state,
    renewPasswordLoading: false,
    renewPasswordSuccess: true
  })),
  on(RenewPasswordActions.renewPasswordFailure, (state, { error }) => ({
    ...state,
    renewPasswordErrorMessage: error,
    renewPasswordLoading: false,
    renewPasswordSuccess: false
  })),
  on(RenewPasswordActions.decodeMessageSuccess, (state, { decodedTokenMessage }) => ({
    ...state,
    decodedTokenMessage,
  })),
  on(RenewPasswordActions.decodeMessageFailure, (state, { error }) => ({
    ...state,
    decodedTokenMessageInvalid: true,
    decodedTokenMessageMessageError: error,
  })),
  on(RenewPasswordActions.renewTokenExpired, (state, { error }) => {
    return {
      ...state,
      renewTokenExpired: true,
      renewPasswordLoading: false,
      renewPasswordSuccess: false,
      renewTokenErrorMessage: error,
    };
  }),
);

export function reducer(state: State | undefined, action: Action) {
  return renewPasswordReducer(state, action);
}
